import http from './http';

const getProfile = () => {
    return http.get('/private/profile');
};

export default {
    getProfile,
};
